module.exports = __webpack_public_path__ + "static/media/image1.117cba66.jpg";